<SimpleField {label} {required} {hints} {stacked}>
  <Textarea 
    bind:value={value}
    {size} w={width}
    {disabled} 
    bg="white" 
    px="sm" py="xs"
    />
</SimpleField>

<script>
  import { Textarea } from 'svelte-stylo'
  import SimpleField from './SimpleField.svelte'

  export let 
    label = '',
    required = null,
    size = "100%",
    disabled = null,
    hints = null,
    stacked = false,
    value;

  let
    width = (size === '100%') ? size : null;

</script>
